// 导出配置的路由器
export default [{
  path: '/possessionCenter',
  component: () => import('@/layout/index'),
  redirect: 'possessionCenter/orderManager',
  meta: {title: '财务中心', icon: 'icon-shouru2', perms: ['bee:possession']},
  children: [
   /* {
      path: 'incomeView',
      component: () => import('@/module/possessionCenter/page/incomeView.vue'),
      meta: {title: '收入总览(总监控版)', icon: 'icon-zhangdan', perms: ['bee:order:screenAll']}
    },
    {
      path: 'operatorIncomeView',
      component: () => import('@/module/possessionCenter/page/operatorIncomeView.vue'),
      meta: {title: '收入总览(运营商版)', icon: 'icon-zhangdan', perms: ['bee:order:screenOperator']}
    },*/
    {
      path: 'orderManager',
      component: () => import('@/module/possessionCenter/page/order/manage.vue'),
      meta: {title: '订单管理', icon: 'icon-order', perms: ['bee:order:report']}
    },
    {
      path: 'settleManager',
      component: () => import('@/module/possessionCenter/page/settle/manage.vue'),
      meta: {title: '账单管理', icon: 'icon-zhangdan', perms: ['bee:possession:cecOrder']}
    },
   /* {
      path: 'groupBill',
      component: () => import('@/module/possessionCenter/page/groupBill/manage.vue'),
      meta: {title: '集团账单', icon: 'icon-jituan2', perms: ['bee:possession:groupOrder']}
    },
    {
      path: 'interactiveOrder',
      component: () => import('@/module/possessionCenter/page/cecOrder/manage.vue'),
      meta: {title: '互联互通订单', icon: 'icon-zhangdan1', perms: ['bee:possession:cecOrder']}
    },*/
    {
      path: 'invoiceManager',
      component: () => import('@/module/possessionCenter/page/invoice/manage.vue'),
      meta: {title: '发票管理', icon: 'icon-fapiao1', perms: ['bee:order:invoice']}
    },
    {
      path: 'withdrawal',
      component: () => import('@/module/possessionCenter/page/withdrawal/list.vue'),
      meta: {title: '余额提现', icon: 'icon-zhangdan', perms: ['bee:operator:wallet']}
    },
    {
      path: 'balanceRecord',
      component: () => import('@/module/possessionCenter/page/balanceRecord/list.vue'),
      meta: {title: '余额变动记录', icon: 'icon-zhangdan', perms: ['bee:operator:withdraw']}
    },
   /* {
      path: 'billManager',
      component: () => import('@/module/possessionCenter/page/statement/billManager.vue'),
      meta: {title: '对账单管理', icon: 'icon-zhangdan',perms: ['bee:order:bill']}
    }*/
  ]
}]



// WEBPACK FOOTER //
// ./src/module/possessionCenter/router/index.js